import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { PlanCategory, PlanType } from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'subscription-category-display',
  templateUrl: './subscription-category-display.component.html',
  styleUrls: ['./subscription-category-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class SubscriptionCategoryDisplayComponent implements OnInit {
  private cd = inject(ChangeDetectorRef);

  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);
  type!: any;
  ngOnInit() {
    this.columnData.subscribe({
      next: (item: any) => {
        this.setPlanType(item);
      },
    });
  }

  setPlanType(cData: any) {
    if (cData?.subscription_category)
      this.type = Object.entries(PlanType)
        .map(([key, value]) => ({ id: key, value: value }))
        .find((item: any) => {
          return item.id == cData.subscription_category;
        })?.value;
    if (cData?.clt_subs_type) {
      this.type = PlanCategory[cData?.clt_subs_type];
    }

    if (cData?.clt_subs_category) {
      this.type = PlanCategory[cData?.clt_subs_category];
    }

    if (cData?.plan_category) {
      this.type = PlanType[cData?.plan_category as keyof typeof PlanType];
    }
  }
}
